/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { /*IHeader,*/ IMapViewProps } from './eve-map';

/**
 * Render the heading.
 * @param param0 -- Heading props.
 * @param param0.headerProps -- Heading Props.
 * @param param0.heading -- Heading Node.
 * @returns -- Returns the node.
 */
// const MapHeader: React.FC<IHeader> = ({ headerProps, heading }) => <Node {...headerProps}>{heading}</Node>;

/**
 * Renders the map view props.
 * @param param0 -- Map view props.
 * @param param0.ModuleProps -- Module props.
 * @param param0.Header -- Header props.
 * @param param0.MapProps -- Map props.
 * @returns -- Returns the map module.
 */
const MapView: React.FC<IMapViewProps> = props => {
    const { ModuleProps, MapProps } = props;
    return (
        <Module {...ModuleProps}>
            <div className='eve-map_container'>
                {renderDealerList(props)}
                {/* Not using the map header - can remove and disable the configuration field? */}
                {/* {Header && <MapHeader {...Header} />}, */}
                <Node {...MapProps} />
            </div>
        </Module>
    );
};

const renderDealerList: React.FC<IMapViewProps> = props => {
    const {
        dealerResultContainerProps,
        locationsMessage,
        search,
        state,
        spinner,
        locationsList,
        noLocationsMessage,
        pagination
        // selectedLocation,
        // dealerDetailsModal // may just have the details appear by extending the selected dealer in the list
    } = props;
    return (
        <Node {...dealerResultContainerProps!}>
            {locationsMessage}
            {search}
            {/* {pagination} */}
            {state.isSearchInProgress ? spinner : <>{locationsList ? locationsList : noLocationsMessage}</>
            // {/* <>{noLocationsMessage}</> */}
            }
            {pagination}
            {/* Make the renderSelectedDealer function work??? */}
            {/* <Node {...dealerDetailsModal!}>{selectedLocation && renderSelectedDealer(selectedLocation)}</Node> */}
        </Node>
    );
};

export default MapView;
